export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/professionalIcon-2ff657fb4b12013b9e2b089cf3f3fbce.svg";